import { useTranslation } from 'react-i18next';

import { UserRole } from 'interfaces';
import { Banner } from 'storybook';
import { getDayLabel } from 'utils/functions';

import styles from './RetentionDateExpiredBanner.module.css';

type RetentionDateExpiredBannerProps = {
   role: Extract<UserRole, 'ROLE_SYSTEM_ADMIN' | 'ROLE_CLIENT'>;
   delayTimeInDaysFromRetentionDate: number;
};

const RetentionDateExpiredBanner = ({
   role,
   delayTimeInDaysFromRetentionDate,
}: RetentionDateExpiredBannerProps) => {
   const { t } = useTranslation();

   const roleKey =
      role === 'ROLE_CLIENT'
         ? 'retentionDateExpiredBanner.client'
         : 'retentionDateExpiredBanner.admin';

   const dayLabel = getDayLabel(delayTimeInDaysFromRetentionDate);

   return (
      <Banner
         variant="error"
         children={t(roleKey, {
            count: delayTimeInDaysFromRetentionDate,
            dayLabel,
         })}
         fullWidth
         className={styles.banner}
      />
   );
};

export default RetentionDateExpiredBanner;
